import { a11yProps, EstadoTransitoInventarioENUM, useTabsFormOnly } from "@/shared";
import { CustomTabPanel, FormTabsOnly, SingleBoxTableTabsOnly, SingleTableBoxScene } from "@/shared/components/ui";
import { Tab } from "@mui/material";
import TableRecepcionTransitoInventario from "../../shared/table_recepcion_transito_inventario/TableRecepcionTransitoInventario";

export default function TransitoTransferenciaInventarioPage() {

  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 0
  });


  return (
    <SingleTableBoxScene
      title="↪️ Recepción de Transferencia Inventario"
    >
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label={'Transito'} value={0} {...a11yProps(0)} />
          {/* <Tab label={'Recepcion Parcial'} value={1} {...a11yProps(1)} /> */}
          <Tab label={'Finalizado'} value={1} {...a11yProps(1)} />
          <Tab label={'Pendiente Regulación'} value={2} {...a11yProps(2)} />
          <Tab label={'Pendiente Documento'} value={3} {...a11yProps(2)} />
          <Tab label={'Rechazados'} value={4} {...a11yProps(3)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>
      <CustomTabPanel index={valueTab} value={0}>
        <TableRecepcionTransitoInventario />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={1}>
        <TableRecepcionTransitoInventario
          enable_action={false}
          estado_transito={EstadoTransitoInventarioENUM.ENTREGADO}
        />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={2}>
        <TableRecepcionTransitoInventario
          estado_transito={EstadoTransitoInventarioENUM.PENDIENTE_REGULACION}
          regulacion={true}
        />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={3}>
        <TableRecepcionTransitoInventario
          estado_transito={EstadoTransitoInventarioENUM.PENDIENTE_DOCUMENTO}
          enable_action={false}
        />
      </CustomTabPanel>
      <CustomTabPanel index={valueTab} value={4}>
        <TableRecepcionTransitoInventario
          estado_transito={EstadoTransitoInventarioENUM.RECHAZADO}
          enable_action={false}
        />
      </CustomTabPanel>
    </SingleTableBoxScene>
  )
}


